export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvFormElement.vue?vue&type=template&id=2d3830b4&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvFormElement.vue?vue&type=template&id=2d3830b4&lang=pug&
// module id = 191
// module chunks = 0 1